module.exports = __webpack_public_path__ + "img/1day.6061d7d3.svg";